import {Component, ViewChild, EventEmitter} from '@angular/core';
import {MatPaginator, MatDialog, MatSort} from '@angular/material';
import 'rxjs/add/operator/startWith';
import 'rxjs/add/observable/merge';
import 'rxjs/add/operator/map';
import {generalService} from '../../services/general.service';
import {usuarioAddEditComponent} from '../agregar-editar/usuarioAddEdit.component';
import { DataService } from '../../utils/data.service';
import { modalComponent } from '../../utils/modal/modal.component';
import {Usuario} from '../../models/usuario';
import {DataSourceGrid,datosGrid} from '../../utils/sourceGrid.component';

@Component({
  selector: 'my-usuario-consultar',
  styleUrls: [],
  templateUrl: 'usuarioConsultar.component.html',
  providers: [generalService]
})

export class usuarioConsultarComponent {
  public usuario:Usuario;
  displayedColumns = ['acciones', 'USER_NAME', 'COMPANY', 'ORGANIZATION', 'EMAIL'];
  public datosUsuarios:Array<any>;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  dataSource: DataSourceGrid | null;
  public gridDatos:any; 
  
  constructor(private _generalService: generalService, public dialog: MatDialog, public dataService: DataService/*, private sanitizer: DomSanitizer*/) {
     this.datosUsuarios = new Array();
     this.usuario = new Usuario();
  }

  consultarUsuarios(){
    let usuario: any = {};
    usuario.loacs = sessionStorage.getItem("acslo");
    this._generalService.metodoCallParams(usuario,"usuario/consultarUsuarios").subscribe(
        result => {
          this.datosUsuarios = JSON.parse(result);
          this.gridDatos = new datosGrid(this.datosUsuarios);
          this.dataSource = new DataSourceGrid(this.gridDatos, this.paginator, this.sort);
          if(this.datosUsuarios.length <= 0)
          {
            $(".mat-row").remove(".mat-row");
          }
        },
        error => {
          var errorMsj = <any>error;
          console.log(errorMsj);
        }
      );
  }

  ngOnInit() {
    this.consultarUsuarios();
  }

  editar(USER_ID){
    this.dataService.id = USER_ID;
    this.dataService.tipo = "editar";
    const dialogRef = this.dialog.open(usuarioAddEditComponent, {disableClose: true, width:'100%', maxWidth:'50%', panelClass: 'full-width-dialog'});
    this.dataService.dialogRef = dialogRef; 
    dialogRef.afterClosed().subscribe((result) => {
      if(this.dataService.guardado){
        this._generalService.toastCall("El registro se modificó exitosamente!");
        this.consultarUsuarios();     
      }
      else if(this.dataService.mensajeAlert != "" && this.dataService.mensajeAlert != undefined){
         this.modal("alert", this.dataService.mensajeAlert);
      }
    });
  }

  agregar(){
    this.dataService.tipo = "agregar";
    const dialogRef = this.dialog.open(usuarioAddEditComponent, {disableClose: true, width:'100%', maxWidth:'50%', panelClass: 'full-width-dialog'});
    this.dataService.dialogRef = dialogRef;
    dialogRef.afterClosed().subscribe((result) => {
      if(this.dataService.guardado){
        this._generalService.toastCall("El registro se agregó exitosamente!");
        this.consultarUsuarios();
      } 
    });
  }

  eliminarConfirm(data: any){
    this.usuario.USER_ID = data.USER_ID;
    this.usuario.loacs = sessionStorage.getItem("acslo");
    let eliminarHttp = new EventEmitter<any>();
    eliminarHttp.subscribe(
      (response: any) => {
        if(response){
            this.modal("alert", response);
        }else{
            this.consultarUsuarios();
        }
      }
    );
    this._generalService.modal(eliminarHttp, "confirm", "¿Desea eliminar el usuario " + data.USER_NAME + "?", "usuario/eliminarUsuario/", this.usuario);
  }

  modal(tipo, mensaje){
    this.dataService.modal = tipo;
    this.dataService.mensaje = mensaje;
    const dialogModal = this.dialog.open(modalComponent, {disableClose: true});
    this.dataService.dialogModal = dialogModal;
    dialogModal.afterClosed().subscribe((result) => {
        this.consultarUsuarios();
    });
  }

  searchFilter(searchTerm: string) {
    if(this.gridDatos.length <= 0) {
      this.dataSource = undefined;
    } else {
      let filteredUsers = this.gridDatos;
      if(searchTerm != "") {
        filteredUsers = this.gridDatos.slice().filter((usuario: any) => {            
          if (usuario.USER_NAME.toLowerCase().indexOf(searchTerm.toLowerCase()) != -1 ||
              usuario.EMAIL.toLowerCase().indexOf(searchTerm.toLowerCase()) != -1 ||
              usuario.COMPANY.toLowerCase().indexOf(searchTerm.toLowerCase()) != -1 ||
              usuario.ORGANIZATION.toLowerCase().indexOf(searchTerm.toLowerCase()) != -1)
              return true;
          else
              return false;
        });
      }
      this.dataSource = new DataSourceGrid(filteredUsers, this.paginator, this.sort);
      //this.numberOfRecords = filteredUsers.length;
    }
}

}

export interface UserData {
  USER_ID:number;
  USER_NAME:string;
  EMAIL:string;
  COMPANY:string;
  ORGANIZATION:string;
}


// WEBPACK FOOTER //
// ./src/app/usuario/consultar-eliminar/usuarioConsultar.component.ts